import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '../utils/cn.ts'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {}
export interface CardTitleProps extends HTMLAttributes<HTMLHeadingElement> {}
export interface CardSubtitleProps extends HTMLAttributes<HTMLParagraphElement> {}
export interface CardContentProps extends HTMLAttributes<HTMLDivElement> {}
export interface CardHelperProps extends HTMLAttributes<HTMLDivElement> {}
export interface CardActionProps extends HTMLAttributes<HTMLDivElement> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('card', className)} {...props} />
  ),
)
Card.displayName = 'Card'

export const CardTitle = forwardRef<HTMLHeadingElement, CardTitleProps>(
  ({ className, ...props }, ref) => (
    <h3 ref={ref} className={cn('card-title', className)} {...props} />
  ),
)
CardTitle.displayName = 'CardTitle'

export const CardSubtitle = forwardRef<HTMLParagraphElement, CardSubtitleProps>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('card-subtitle', className)} {...props} />
  ),
)
CardSubtitle.displayName = 'CardSubtitle'

export const CardContent = forwardRef<HTMLDivElement, CardContentProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('card-content', className)} {...props} />
  ),
)
CardContent.displayName = 'CardContent'

export const CardHelper = forwardRef<HTMLDivElement, CardHelperProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('card-helper', className)} {...props} />
  ),
)
CardHelper.displayName = 'CardHelper'

export const CardAction = forwardRef<HTMLDivElement, CardActionProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('card-action', className)} {...props} />
  ),
)
CardAction.displayName = 'CardAction'
